"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CommentsService", {
    enumerable: true,
    get: function() {
        return CommentsService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _models = require("../models");
const _catchError = require("~/helpers/catchError");
const _helpers = require("~/helpers");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _Comment = /*#__PURE__*/ _interop_require_default(require("~/models/Comment"));
const _mailservice = require("~/services/mail/mail.service");
const _Mail = require("~/interface/Mail");
const _NocoSocket = /*#__PURE__*/ _interop_require_default(require("~/socket/NocoSocket"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let CommentsService = class CommentsService {
    async commentRow(context, param) {
        var _param_user, _param_user1;
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/CommentReq', param.body);
        const res = await _Comment.default.insert(context, _extends({}, param.body, {
            created_by: (_param_user = param.user) == null ? void 0 : _param_user.id,
            created_by_email: (_param_user1 = param.user) == null ? void 0 : _param_user1.email
        }));
        const model = await _models.Model.getByIdOrName(context, {
            id: param.body.fk_model_id
        });
        const base = await _models.Base.getByTitleOrId(context, model.base_id);
        await this.mailService.sendMail({
            mailEvent: _Mail.MailEvent.COMMENT_CREATE,
            payload: {
                base,
                model,
                user: param.user,
                comment: res,
                rowId: param.body.row_id,
                req: param.req
            }
        });
        this.appHooksService.emit(_nocodbsdk.AppEvents.COMMENT_CREATE, {
            base,
            model,
            user: param.user,
            comment: res,
            rowId: param.body.row_id,
            req: param.req,
            context
        });
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.COMMENT_EVENT,
            payload: {
                action: 'add',
                payload: res,
                id: param.body.row_id
            },
            scopes: [
                model.id
            ]
        }, context.socket_id);
        return res;
    }
    async commentDelete(context, param) {
        const comment = await _Comment.default.get(context, param.commentId);
        if (comment.created_by !== param.user.id || comment.is_deleted) {
            _catchError.NcError.get(context).unauthorized('Unauthorized access');
        }
        const res = await _Comment.default.delete(context, param.commentId);
        const model = await _models.Model.getByIdOrName(context, {
            id: comment.fk_model_id
        });
        this.appHooksService.emit(_nocodbsdk.AppEvents.COMMENT_DELETE, {
            base: await _models.Base.getByTitleOrId(context, model.base_id),
            model: model,
            user: param.user,
            comment: comment,
            rowId: comment.row_id,
            req: param.req,
            context
        });
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.COMMENT_EVENT,
            payload: {
                action: 'delete',
                payload: comment,
                id: comment.row_id
            },
            scopes: [
                model.id
            ]
        }, context.socket_id);
        return res;
    }
    async commentList(context, param) {
        return await _Comment.default.list(context, param.query);
    }
    async commentsCount(context, param) {
        return await _Comment.default.commentsCount(context, {
            fk_model_id: param.fk_model_id,
            ids: param.ids
        });
    }
    async commentUpdate(context, param) {
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/CommentUpdateReq', param.body);
        const comment = await _Comment.default.get(context, param.commentId);
        if (comment.created_by !== param.user.id || comment.is_deleted) {
            _catchError.NcError.get(context).unauthorized('Unauthorized access');
        }
        const res = await _Comment.default.update(context, param.commentId, {
            comment: param.body.comment
        });
        const model = await _models.Model.getByIdOrName(context, {
            id: comment.fk_model_id
        });
        const base = await _models.Base.getByTitleOrId(context, model.base_id);
        await this.mailService.sendMail({
            mailEvent: _Mail.MailEvent.COMMENT_CREATE,
            payload: {
                base,
                model,
                user: param.user,
                comment: res,
                rowId: res.row_id,
                req: param.req
            }
        });
        this.appHooksService.emit(_nocodbsdk.AppEvents.COMMENT_UPDATE, {
            base,
            model,
            user: param.user,
            comment: _extends({}, comment, {
                comment: param.body.comment
            }),
            rowId: comment.row_id,
            req: param.req,
            context
        });
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.COMMENT_EVENT,
            payload: {
                action: 'update',
                payload: res,
                id: comment.row_id
            },
            scopes: [
                model.id
            ]
        }, context.socket_id);
        return res;
    }
    constructor(appHooksService, mailService){
        this.appHooksService = appHooksService;
        this.mailService = mailService;
    }
};
CommentsService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService,
        typeof _mailservice.MailService === "undefined" ? Object : _mailservice.MailService
    ])
], CommentsService);
